<template>
  <b-col cols="12">
    <vs-card>

      <vs-button id="button-with-loading" class="vs-con-loading__container" color="success" style="border-radius: 5px"
        type="gradient" @click="sevkiyatolustur()">
        Sevkiyat oluştur
      </vs-button>
      <vs-button id="button-with-loading" class="  vs-con-loading__container" @click="cekiListForExcel()"
        style="border-radius: 5px" type="gradient">Excel
        işlemleri</vs-button>
    </vs-card><vs-card>
      <ag-grid-vue style="width: 100%; height: 400px; margin-top: 25px" class="ag-theme-alpine"
        :defaultColDef="defaultColDef" :columnDefs="columnDefs" :rowData="rowdata" :localeText="localeText"
        @grid-ready="onGridReady" @first-data-rendered="onFirstDataRendered" :rowSelection="rowSelection">
      </ag-grid-vue>
    </vs-card>
    <SiparisEklePopup :isSidebarActive="popupActivoSip" :selectedRowData="selectedRow" @closeSidebar="popupClose" />
    <CekiListForExcel :isSidebarActive="excelPopupActive" @closeSidebar="toggleDataSidebar" />
  </b-col>
</template>

<script>
import SiparisEklePopup from "../components/uzum-components/paketleme-components/SiparisEklePopup.vue";
import moment from "moment";
import state from "../../store/state";
import Store from "../../store/store";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import CekiDetayBtn from "../components/uzum-components/paketleme-components/CekiDetayBtn.vue";
import CekiListForExcel from "./CekiListForExcel.vue";
import StatusGorunumCellRenderer from "./CellRenderers/StatusGorunumCellRenderer"
export default {
  data() {
    return {
      selectedRow: [],
      popupActivoSip: false,
      excelPopupActive: false,
      localeText: null,
      rowSelection: null,
      rowdata: null,
      columnDefs: [],
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
    };
  },
  methods: {
    sevkiyatolustur() {
      this.popupActivoSip = true;
    },
    siparisKalemiSec(tr) { 
      this.selectedRow = tr
      this.popupActivoSip = true;
    },
    popupClose() { 
      this.selectedRow = []
      this.popupActivoSip = false;
    },
    getCekiList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        sevkMi: "sevk", marketplace: "Evidea", token: Store.state.tokenId, listDateStart: vm.listDateStart, listDateEnd: vm.listDateEnd, orderNumber: vm.orderNumber
      }; 
      soap.createClient(url, function (err, client) {
        client.cekiListesi(args, function (err, result) {
          vm.veriler = JSON.parse(result.cekiListesiResult); 
          vm.listDateStart = "";
          vm.listDateEnd = ""
          vm.columnDefs = [];

          vm.rowdata = vm.veriler

          let columnList = Object.keys(vm.rowdata[0]);
          columnList.forEach((val, index) => {
            if (val.includes("Tarihi")) { 
              vm.columnDefs.push({
                field: val,
                filter: "agDateColumnFilter"

              });
            } else if (val.includes("durum")) { 
              vm.columnDefs.push({
                field: val,
                filter: "agDateColumnFilter",
                cellRenderer: "StatusGorunumCellRenderer",
              });
            }
            else if (val.includes("id")) { }
            else if (!val.includes("id"))
              vm.columnDefs.push({
                field: val,
                filter: "agSetColumnFilter",
                cellRenderer: "TextGorunumCellRenderer",
              });
          })
          vm.columnDefs.push({
            width: 150,
            field: "İşlemler",
            cellRendererFramework: "CekiDetayBtn",
            autoHeight: true
          });
        });
      });
    },
    toggleDataSidebar(val = false) {
      this.excelPopupActive = val
    },
    cekiListForExcel() {
      this.excelPopupActive = true
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    closePopupAction(flag) {
      this.popupActivo = false;
    },


  },
  components: {
    StatusGorunumCellRenderer,
    SiparisEklePopup,
    CekiListForExcel,
    AgGridVue,
    CekiDetayBtn,
  },
  created() {
    this.getCekiList();
  },
  mounted() {
    this.$root.$on("getCekiList", params => {
      this.getCekiList(params);
    });
    this.$root.$on("closePopupAction", params => {
      this.closePopupAction(params);
    });
    this.$root.$on("siparisKalemiSec", params => {
      this.siparisKalemiSec(params);
    });

  },
  beforeDestroy() {
    this.$root.$off("getCekiList");

    this.$root.$off("siparisKalemiSec");

    this.$root.$off("closePopupAction");

  },

};
</script>
